module.exports = __webpack_public_path__ + "prod/1.2.3/img/logo.f0c47f7a.png";